import { Flex, Box } from "@chakra-ui/react";
import { Caption } from "src/atoms/typography";
import SvgContainer from "src/components/SvgContainer";

export default function ActionItem({ icon, label, onClick }) {
  return (
    <Flex
      justifyContent="start"
      alignItems="center"
      flexDirection="column"
      mx="2px"
      width="60px"
    >
      <Box
        onClick={onClick}
        p="8px"
        bg="iconBackground"
        borderRadius="100%"
        transition="all 100ms ease-in"
        _hover={{
          bg: "white20"
        }}
        _active={{
          bg: "white8"
        }}
      >
        <SvgContainer icon={icon} fill="highEmphasis" />
      </Box>
      <Caption mt="6px" textAlign="center" color="mediumEmphasis">
        {label}
      </Caption>
    </Flex>
  );
}
